import React from "react";
import { bool, func } from "prop-types";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { Modal } from "shared/components";
import CommonIncidentForm from "./CommonIncidentForm";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";

const ModalCommonIncident = (props) => {
  const { t, isCurrentStep, onPreviousStep, onNextStep, onReset } = props;
  return (
    <Modal
      isOpen={isCurrentStep}
      onClose={onReset}
      title={t("MSG_0194")}
      icon={IconRepair}
      ariaHideApp={false}
    >
      <CommonIncidentForm
        onReset={onReset}
        onPreviousStep={onPreviousStep}
        onNextStep={onNextStep}
      />
    </Modal>
  );
};

ModalCommonIncident.propTypes = {
  onCreateIncident: func.isRequired,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
  isOpen: bool,
};

ModalCommonIncident.defaultProps = {
  isOpen: false,
  isSiebel: false,
};

const enhance = compose(translate());

export default enhance(ModalCommonIncident);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalCommonIncident/index.js